export default {
  missions: {},
  hardware: {
    deployers: [],
    spacecraft: [],
  },
};
